import { useState } from "react";
import { useLocation } from "react-router-dom";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import ContactHeader from "../components/contact/ContactHeader";
import BranchBar from "../components/contact/BranchBar";
import ContactForm from "../components/contact/ContactForm";
import LabelSelector from "../components/contact/LabelSelector";
import AssigneeCard from "../components/contact/AssigneeCard";

const LABELS = [
  "Pitch a guest / topic",
  "Brand & sponsorship",
  "Press & media",
  "Just say hi",
];

const ASSIGNEES = [
  { name: "Ellen", role: undefined, avatarColor: "#c989b7" },
  { name: "Eden", role: undefined, avatarColor: "#6d0016" },
];

export function Contact() {
  const { state } = useLocation();
  const requested = (state as { label?: string } | null)?.label;
  const initialLabel =
    requested && LABELS.includes(requested) ? requested : LABELS[0];
  const [selectedLabel, setSelectedLabel] = useState(initialLabel);

  return (
    <div className="min-h-screen bg-cream">
      <Nav />
      <ContactHeader />

      <div className="max-w-6xl  mx-auto px-6 pb-20">
        <div className="grid grid-cols-1 md:grid-cols-[1fr_260px] gap-8 items-start">
          {/* Main form column — second on mobile, first on desktop */}
          <div className="order-2 md:order-1 bg-dustyrose/20 rounded-lg p-6 sm:p-8">
            <BranchBar label={selectedLabel} />
            <ContactForm selectedLabel={selectedLabel} />
          </div>

          {/* Sidebar — first on mobile, second on desktop */}
          <aside className="flex flex-col gap-5 order-1 bg-dustyrose/20 rounded-lg p-4 md:order-2">
            <LabelSelector
              labels={LABELS}
              selected={selectedLabel}
              onChange={setSelectedLabel}
              stats={[
                { value: "142", label: "issues" },
                { value: "18", label: "PRs" },
                { value: "avg response", label: "" },
                { value: "2 days", label: "" },
              ]}
            />

            {/* Assignees */}
            <div
              className="border border-stone-200 rounded"
              style={{ backgroundColor: "#faf9f4" }}
            >
              <p
                className="font-montserrat font-semibold text-stone-600 uppercase px-3 py-2 border-b border-stone-200"
                style={{ fontSize: "13px", letterSpacing: "0.14em" }}
              >
                Assignees
              </p>
              <div className="flex flex-col gap-3 px-3 py-3">
                {ASSIGNEES.map((a) => (
                  <AssigneeCard key={a.name} {...a} />
                ))}
              </div>
            </div>
          </aside>
        </div>
      </div>

      <Footer />
    </div>
  );
}
